export default number => {
  if (number[0] === '+') {
    return `+${number.replace(/\D/g, '')}`;
  }
  return number.replace(/\D/g, '');
};
